export default __webpack_public_path__ + "static/media/bike_card_2.91fa534d.png";